import { useEffect, useMemo } from 'react';

import { useNextScheduledContributionDateStore } from '../../stores';
import useScheduledContributionStore from '../../stores/useScheduledContribution.store';
import { useScheduledContributionSummaryCalendarsQuery } from '../queries';

export default () => {
  const calendarId = useScheduledContributionStore(state=> state.state.calendarId);
  const startDate = useScheduledContributionStore(state=> state.state.startDate);
  const handleSetNextScheduledTime = useNextScheduledContributionDateStore(state=> state.handleSetNextScheduledTime);

  const { formattedData } = useScheduledContributionSummaryCalendarsQuery({
    calendarId: calendarId || '',
    startDate,
  });

  const currentScheduledTime = useMemo(() => {
    if (formattedData.length && formattedData.length > 0) {
      return formattedData[0].scheduledTime;
    }
    return undefined;
  }, [formattedData]);

  useEffect(() => {
    handleSetNextScheduledTime(currentScheduledTime);
  }, [currentScheduledTime, handleSetNextScheduledTime]);

  return {
    formattedData,
    currentScheduledTime,
  };
};
